import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import TrainingAttendance from '@/models/TrainingAttendance.js'

export const useTrainingAttendanceStore = defineStore('trainingAttendanceStore', () => {
  let syncableModel = useSyncableModel(useApiResource('training_attendances'), {
    className: TrainingAttendance.modelName.name,
    paramKey: TrainingAttendance.modelName.paramKey
  })

  function findAllByScheduleUuid(schedule_uuid) {
    return syncableModel.collection.value.filter((e) => {
      return e.training_schedule_uuid == schedule_uuid
    })
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    findAllByScheduleUuid,
    $reset
  }

}, {
  persist: true
})

